import {
  SET_COMMENTS_STATUS,
  SET_COMMENTS_COURSE,
  SET_COMMENTS_LESSON
} from '@/store/mutation-types'

export default {
  [SET_COMMENTS_STATUS] (state, payload) {
    state.searchCommentsStatus = payload
  },
  [SET_COMMENTS_COURSE] (state, payload) {
    state.searchCommentsCourse = payload
  },
  [SET_COMMENTS_LESSON] (state, payload) {
    state.searchCommentsLesson = payload
  }
}



// WEBPACK FOOTER //
// ./src/components/comments/store/mutations.js